import { Controller } from "@hotwired/stimulus"

// Compte à rebours synchronisé sur le timestamp ends_at du serveur.
// Met à jour toutes les 250ms jusqu'à 0. Affiche les secondes en entier.
export default class extends Controller {
  static targets = ["display"]
  static values = { endsAt: String }

  connect() {
    this.endsAt = new Date(this.endsAtValue).getTime()
    this.tick()
    this.interval = setInterval(() => this.tick(), 250)
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval)
  }

  tick() {
    const now = Date.now()
    const remainingMs = Math.max(this.endsAt - now, 0)
    const remainingSeconds = Math.ceil(remainingMs / 1000)
    this.displayTarget.textContent = remainingSeconds
    if (remainingMs <= 0) {
      clearInterval(this.interval)
    }
  }
}
